const removeFromString = (string, remove) => {
  return string.replace(remove, "");
};
const roundToThousand = (nubmer) => {
  return Number(String(nubmer).substring(0, String(nubmer).length - 3) + "000");
};
export { removeFromString, roundToThousand };
